import Box from "@mui/material/Box";
import * as React from "react";
import { useState } from "react";

import {
  DashboardMenuItem,
  MenuItemLink,
  MenuProps,
  usePermissions,
  useSidebarState,
  useTranslate,
} from "react-admin";

import AddBoxIcon from "@mui/icons-material/AddBox";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import { IconButton, MenuItem, Typography } from "@mui/material";
import MuiMenu from "@mui/material/Menu";
import { styled } from "@mui/material/styles";
import { Link, useLocation } from "react-router-dom";
import Achpayments from "../achpayments";
import applications from "../applications";
import Customers from "../customers";
import loans from "../loans";
import reports from "../reports";
import CampaignsIcon from "../unit/svgIcon/CampaignIcon";
import PartnerIcon from "../unit/svgIcon/PartnerIcon";
import HMSmallLogo from "./HMSmallLogo";
const ProductDefaultIcon = () => {
  return <AddBoxIcon sx={{ color: "white", fontSize: "24px", ml: "0.5px" }} />;
};
const ProductDisableIcon = () => {
  return (
    <AddBoxIcon sx={{ color: "#888888", fontSize: "24px", ml: "0.5px" }} />
  );
};
const BillingIcon = () => {
  return <RequestQuoteIcon />;
};

const AccountIcon = () => {
  return (
    <img
      src="/public/icon/account-white.png"
      style={{ width: "22px", height: "22px" }}
    />
  );
};
type MenuName =
  | "menuCatalog"
  | "menuSales"
  | "menuCustomers"
  | "menuAdmins"
  | "menuReports"
  | "menuApplications"
  | "menuLoans";

const CustomMenuItemLink = styled(MenuItemLink)({
  "&>div": {
    padding: "0px 0px 0px 0px",
  },
});
const PartnersIcon = () => {
  return <PartnerIcon color="white" size="21.5px" />;
};
const PartnersDisabledIcon = () => {
  return <PartnerIcon color="#888888" size="21.5px" />;
};

const HelpMenu = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleOpenZendeskWidget = () => {
    const zendesk = (window as Window & { zE?: (...args: any[]) => void }).zE;

    if (typeof zendesk === "function") {
      zendesk("webWidget", "show");
      zendesk("webWidget", "open");
    }

    handleClose();
  };

  return (
    <>
      <IconButton
        sx={{
          ml: 1,
          mb: 1,
          float: "inherit",
          position: "absolute",
          bottom: "0",
          color: "white",
        }}
        onClick={handleClick}
      >
        <HelpOutlineIcon sx={{ color: "white" }} />
      </IconButton>
      <MuiMenu
        id="menu-help"
        aria-labelledby="menu-help"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        sx={{
          "& .MuiMenuItem-root": {
            padding: "10 0",
            m: "0px",
            textAlign: "center",
            width: "200px",
            background: "none",
          },
          "& .MuiMenuItem-root:hover": {
            background: "none",
          },
        }}
      >
        <MenuItem onClick={handleOpenZendeskWidget}>Contact Support</MenuItem>
        <MenuItem
          onClick={() =>
            window.open(
              "https://institution.zendesk.com/hc/en-us/sections/43186045727757-FAQ-Beta-Site"
            )
          }
        >
          Find the Answer
        </MenuItem>
        <MenuItem>
          <Link
            to='/requestdata?filter={"status":"New"}'
            style={{
              color: "inherit",
              textDecoration: "none",
            }}
          >
            Request Data Change
          </Link>
        </MenuItem>
        {/* <MenuItem
          onClick={() =>
            window.open(
              "https://institution.zendesk.com/hc/en-us/sections/43186045727757-FAQ-Beta-Site"
            )
          }
        >
          Send Feedback
        </MenuItem> */}
      </MuiMenu>
    </>
  );
};
const Menu = ({ dense = false }: MenuProps) => {
  const app_env = import.meta.env.VITE_APP_ENV;
  // console.log("app_env", app_env);
  const [state, setState] = useState({
    menuCatalog: true,
    menuSales: true,
    menuCustomers: true,
    menuAdmins: true,
    menuReports: true,
    menuApplications: true,
    menuLoans: true,
  });

  const translate = useTranslate();
  const [open, setOpen] = useSidebarState();
  // setOpen(false);
  React.useEffect(() => {
    setOpen(false);
  }, []);
  const handleToggle = (menu: MenuName) => {
    setState((state) => ({ ...state, [menu]: !state[menu] }));
  };

  const location = useLocation();
  let pathname = location.pathname;

  if (pathname == null || pathname == "" || pathname == "/") {
    pathname = "/dashboard";
  }
  pathname = pathname.replace("/", "");

  const authrole = localStorage.getItem("authrole");
  // const { permissions } = usePermissions();
  const permissions =
    localStorage.getItem("bbaccess")?.toString().split(",") || [];

  // console.log("permissions", permissions);
  return (
    <>
      <Box
        sx={{
          width: "55px",
          marginTop: "0px",
          marginBottom: 1,
          paddingTop: "12px",
          transition: (theme) =>
            theme.transitions.create("width", {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
          "& .MuiListItemIcon-root": {
            marginLeft: "5px",
          },
        }}
        id="main-menu"
      >
        <HMSmallLogo />

        <DashboardMenuItem sx={{ mt: 0 }} />
        {permissions.includes("personal_applications") && (
          <CustomMenuItemLink
            to='/applications?filter={"status":"New","subStatus":"Ready for Review"}'
            state={{ _scrollToTop: true }}
            primaryText="Applications"
            leftIcon={<applications.icon />}
            className={
              pathname === "applications" ? "RaMenuItemLink-active" : ""
            }
          />
        )}
        {permissions.includes("personal_loans") && (
          <CustomMenuItemLink
            to='/loans?filter={"status":"active","curStatus":"OK","filterRemainingterm":"<12 Months"}'
            state={{ _scrollToTop: true }}
            primaryText="Loans"
            leftIcon={<loans.icon />}
            className={pathname === "loans" ? "RaMenuItemLink-active" : ""}
          />
        )}
        {permissions.includes("personal_ach_payments") && (
          <CustomMenuItemLink
            to='/repayment?filter={"status":"repayment_past30unableInitiate"}'
            state={{ _scrollToTop: true }}
            primaryText={"ACH Payments"}
            leftIcon={<Achpayments.icon />}
            className={
              pathname === "achpayment" ||
              pathname === "repayment" ||
              pathname === "disbursement"
                ? "RaMenuItemLink-active"
                : ""
            }
            tooltipProps={{
              title: "ACH payments",
              children: <></>,
            }}
          />
        )}
        {permissions.includes("personal_customers") && (
          <CustomMenuItemLink
            to='/customers?filter={"status":"signUp2026_campaigns"}'
            state={{ _scrollToTop: true }}
            primaryText="Customers"
            leftIcon={<Customers.icon />}
            className={pathname === "customers" ? "RaMenuItemLink-active" : ""}
          />
        )}
        {permissions.includes("personal_partners") && (
          <CustomMenuItemLink
            to="/counselors"
            state={{ _scrollToTop: true }}
            primaryText="Partners"
            leftIcon={<PartnersIcon />}
            className={pathname === "counselors" ? "RaMenuItemLink-active" : ""}
          />
        )}
        {authrole != "admin" && (
          <>
            {permissions.includes("personal_campaigns") && (
              <CustomMenuItemLink
                to="/campaigns"
                state={{ _scrollToTop: true }}
                primaryText="Marketing"
                leftIcon={<CampaignsIcon color="white" size="22px" />}
                className={
                  pathname === "campaigns" || pathname === "couponcodes"
                    ? "RaMenuItemLink-active"
                    : ""
                }
              />
            )}
          </>
        )}

        {app_env === "production" && (
          <>
            {/* {permissions.includes("personal_products") && (
              <Typography
                sx={{
                  color: "white",
                  fontSize: "10px",
                  textAlign: "center",
                  mt: 1,
                  mb: 1,
                }}
              >
                <ProductDisableIcon />
              </Typography>
            )} */}
            {/* {permissions.includes("personal_partners") && (
              <Typography
                sx={{
                  color: "white",
                  fontSize: "10px",
                  textAlign: "center",
                  mt: 1.5,
                  mb: 1,
                }}
              >
                <PartnersDisabledIcon />
              </Typography>
            )}
            {permissions.includes("personal_campaigns") && (
              <Typography
                sx={{
                  color: "white",
                  fontSize: "10px",
                  textAlign: "center",
                  mt: 2.2,
                  mb: 1,
                }}
              >
                <CampaignsIcon color="#888888" size="22px" />
              </Typography>
            )} */}
          </>
        )}

        {permissions.includes("personal_products") && (
          <CustomMenuItemLink
            to='/products?filter={"status":"unsecured","filerLoanTypeId":1}'
            state={{ _scrollToTop: true }}
            primaryText="Products"
            leftIcon={<ProductDefaultIcon />}
            className={pathname === "products" ? "RaMenuItemLink-active" : ""}
          />
        )}

        {/* {authrole != "admin" && ( */}

        {permissions.includes("personal_reports") && (
          <CustomMenuItemLink
            // to={'/reports?filter={"status":"Inception to Date"}'}
            to={'/monthreport?filter={"status":"monthreport"}'}
            state={{ _scrollToTop: true }}
            primaryText="Reports"
            leftIcon={<reports.icon sx={{ ml: "0.5px" }} />}
            className={pathname === "reports" ? "RaMenuItemLink-active" : ""}
          />
        )}

        {/* )} */}
        <HelpMenu />
      </Box>
    </>
  );
};

export default Menu;
